import React from 'react';
import { Box, Typography } from '@mui/material';

interface NoDataFoundProps {
  title?: string;
  subtitle?: string;
  imageWidth?: number;
  imageHeight?: number;
}

const NoDataFound: React.FC<NoDataFoundProps> = ({
  title = "No data found",
  subtitle = "Please try a different filter or navigate to another page.",
  imageWidth = 200,
  imageHeight = 200
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        p: 3,
      }}
    >
      {/* Use the nodata image from the public folder */}
      <Box
        sx={{
          width: imageWidth,
          height: imageHeight,
          mb: 3,
          position: 'relative',
        }}
      >
        <img
          src='/nodata.png'
          alt="No data found"
          style={{ width: '100%', height: '100%', objectFit: 'contain', opacity: 0.9 }}
        />
      </Box>
      <Typography
        variant="h6"
      >
        {title}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ maxWidth: 400 }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

export default NoDataFound; 